import { useCallback, useEffect, useState } from 'react'

import { axiosInstance } from '../../../../../hooks/useAxios'
import { IExpense } from '../../../../../types/expense'
import { PaginationResponseInterface } from '../../../../../types/pagination'

interface Params {
  enabled: boolean // ดึงเฉพาะตอน modal เปิด
  date?: string // YYYY-MM-DD (วันเดียว)
  shopId?: string
}

const PER_PAGE = 100

// รายการค่าใช้จ่าย TikTok ของวันเดียว — filter เหมือน /costs/summary (distributionType=tiktok + ref=shopId)
// เพื่อให้ผลรวมตรงกับยอด "ค่าใช้จ่าย" ที่แสดงในตารางรายวัน
export const useTiktokCostDetails = ({ enabled, date, shopId }: Params) => {
  const [items, setItems] = useState<IExpense[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)

  const fetchCosts = useCallback(async () => {
    if (!date) {
      return
    }
    setIsLoading(true)
    setError(false)
    try {
      const res = await axiosInstance.get<PaginationResponseInterface<IExpense>>(
        '/costs',
        {
          params: {
            page: 1,
            perPage: PER_PAGE,
            startDate: date,
            endDate: date,
            distributionType: 'tiktok',
            ...(shopId ? { ref: shopId } : {}),
          },
        },
      )
      setItems(res.data.records ?? [])
    } catch {
      setError(true)
    } finally {
      setIsLoading(false)
    }
  }, [date, shopId])

  useEffect(() => {
    if (!enabled) {
      return
    }
    setItems([])
    fetchCosts()
  }, [enabled, fetchCosts])

  return { items, isLoading, error }
}
